import React, { useEffect, useState } from "react";
import { Link2, Unplug, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { confirmAsync } from "./ConfirmDialog";

const ICON = { linkedin: "in", meta: "f", youtube: "▶" };

// Connect / disconnect the user's own social accounts. Shown on Integrasi (always) and Social Media (once something is connected).
export function SocialAccounts({ returnTo = "/social", onChange }) {
  const [accounts, setAccounts] = useState(null);
  const load = () => api.get("/social/accounts").then((r) => {
    setAccounts(r.data.items);
    const on = (r.data.items || []).some((a) => a.connected !== false && a.connected);
    sessionStorage.setItem("oryntix_has_social", on ? "1" : "0");
    window.dispatchEvent(new Event("oryntix:social-changed"));
    onChange?.(on);
  }).catch(() => setAccounts([]));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  const connect = async (p) => {
    try {
      const origin = window.location.origin.replace(/\/$/, "");
      const r = await api.get(`/social/${p}/start`, { params: { redirect_uri: `${origin}/api/social/callback`, app_url: origin, return_to: returnTo } });
      window.location.href = r.data.url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal memulai koneksi"); }
  };
  const disconnect = async (p) => { if (!await confirmAsync("Putuskan akun ini?", { confirmLabel: "Putuskan" })) return; await api.delete(`/social/${p}`); load(); };
  return (
    <div className="grid gap-4 md:grid-cols-3" data-testid="social-accounts">
      {(accounts || []).map((a) => (
        <div key={a.id} className="aivora-card p-4" data-testid={`social-acc-${a.id}`}>
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#0B132B] text-sm font-black text-white">{ICON[a.id]}</span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold text-slate-900">{a.label}</p>
              {a.connected ? <p className="flex items-center gap-1 text-xs text-emerald-700" data-testid={`social-status-${a.id}`}><CheckCircle2 size={12} /> {a.account_name || "Terhubung"}{a.pages?.length ? ` · ${a.pages.length} halaman` : ""}</p>
                : <p className="text-xs text-slate-500" data-testid={`social-status-${a.id}`}>{a.configured ? "Belum terhubung" : "Belum dikonfigurasi platform"}</p>}
              <p className="mt-1 text-[11px] text-slate-400">Mendukung: {(a.kinds || []).join(", ")}</p>
            </div>
          </div>
          <div className="mt-3">
            {a.connected ? <button onClick={() => disconnect(a.id)} className="flex items-center gap-1 rounded-lg border border-rose-200 px-3 py-1.5 text-xs font-bold text-rose-600" data-testid={`social-disconnect-${a.id}`}><Unplug size={12} /> Putuskan</button>
              : <button onClick={() => connect(a.id)} disabled={!a.configured} className="btn-grad flex items-center gap-1 rounded-lg px-3 py-1.5 text-xs font-bold disabled:opacity-40" data-testid={`social-connect-${a.id}`}><Link2 size={12} /> Hubungkan</button>}
          </div>
        </div>
      ))}
      {accounts === null && <p className="flex items-center gap-2 text-sm text-slate-400"><Loader2 size={14} className="animate-spin" /> Memuat…</p>}
    </div>
  );
}
